import React, { FC } from 'react';

import { SizeGuide } from 'components/SizeGuide/SizeGuide';
import { Product } from 'models/product';

export const ModalSizeGuide: FC<{
  department: string;
  product: Product;
  setSizeGuideVisible: (val: boolean) => void;
  sizeGuideVisible: boolean;
}> = ({ department, product: { category }, setSizeGuideVisible, sizeGuideVisible }) => {
  return (
    <SizeGuide
      closeSizeGuide={() => {
        setSizeGuideVisible(false);
      }}
      currentCategoryId={category.id}
      department={department}
      isOpen={sizeGuideVisible}
    />
  );
};
